import './eDocument.css';

/**
 * FAZ 6 — Toplu aksiyon şeridi (spec §6.4).
 *
 * ══ ÇOKLU SEÇİMDE DRAWER'IN YERİNİ ALIR ═══════════════════════════════════════════════════════
 * 12 belge seçen kullanıcı, o 12 belgenin zarf UUID'sini YAN YANA OKUMAK istemiyor — hepsini birden
 * GÖNDERMEK istiyor. Detay orada zaten anlamsızdır. Bu yüzden çoklu seçimde detay paneli değil,
 * bu şerit görünür.
 *
 * ══ SEÇİM ≠ DETAY (iş kuralı 8) ═══════════════════════════════════════════════════════════════
 * Checkbox TOPLU AKSİYON içindir (0–N satır). Detay TAM 1 belge gösterir ve yalnız `İncele` ile açılır.
 */
export function EDocumentBulkBar({ count, onResend, onQueryGib, onClear, busy }) {
  if (count === 0) return null;

  return (
    <div className="edoc-bulkbar">
      <span>{count} belge seçili</span>
      <div style={{ flex: 1 }} />

      <button
        type="button"
        className="edoc-abtn edoc-abtn--primary"
        onClick={onResend}
        disabled={busy}
        // Toplu gönderim SESSİZ DAVRANMAZ (iş kuralı 9): uygun olmayanları atlar ve kaçını NİÇİN
        // atladığını söyler. Sessizce hepsini göndermek GİB'de MÜKERRER BELGE demektir.
        title="Yalnız servis/zarf hatası olanlar kuyruğa alınır; gerisi gerekçesiyle atlanır"
      >
        Tekrar Gönder
      </button>

      <button
        type="button"
        className="edoc-abtn"
        onClick={onQueryGib}
        disabled={busy}
        title="Yalnız gönderilmiş belgeler sorgulanabilir — zarf, servise ulaşmamış belgede oluşmaz"
      >
        GİB'e Sorgula
      </button>

      <button type="button" className="edoc-abtn" onClick={onClear} disabled={busy}>
        Seçimi Temizle
      </button>
    </div>
  );
}

export default EDocumentBulkBar;
